export default {
    listing: { method: 'get', url: 'api/guests/protocols' }
}